/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-10 20:44:40
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-08-23 14:06:46
 * @Description: file content
 */
import React, { useState, useEffect, useRef } from 'react'
import mqtt from 'mqtt/dist/mqtt.min'
import globalStore from '@/globalStore'
import { getUserInfo, getLoginStatus } from '@/utils'
import { getUserBindSession } from '@/services/common'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { EVENT_NEMES } from './consts'
import eventBus from '@/utils/eventBus'
import eventMap from '@/utils/gio/eventMap'
import gioTrackEvent from '@/utils/gio'
import { message } from 'antd'

const Mqtt = () => {
  const [client, setClient] = useState(null)
  const msgSessionIdRef = useRef(null)
  const clientRef = useRef(null)

  // 获取用户绑定的消息通道
  const getUserBindSessionAjax = async () => {
    let result: any = {}
    try {
      const { data } = await getUserBindSession({})
      if (data?.code === 0) {
        return data
      }
    } catch (error) {
      console.error('获取用户绑定的消息通道报错')
      result = { code: -1 }
    }
    return result
  }

  const getMqttConfig = () => {
    const info = getUserInfo()
    const protocol = 'wss'
    const isDevAndTest = ['dev', 'test'].includes(
      process?.env?.APP_ENV || window.APP_CONFIG?.APP_ENV,
    )
    const host = isDevAndTest
      ? 'j47bb4ef.ala.cn-hangzhou.emqxsl.cn'
      : 'q4311799.cn-shenzhen.emqx.cloud'
    const clientId = `emqx_react_${  Math.random().toString(16).substring(2, 8)}`
    // ws -> 8083; wss -> 8084
    const port = 8084
    // dev test 直连，pre prod 使用token
    const username = isDevAndTest ? 'sino-cb-test' : info.nickName || 'emqx_test'
    const password = isDevAndTest ? 'sino-cb-test' : info.token
    const url = `${protocol}://${host}:${port}/mqtt`
    const options = {
      clientId,
      username,
      password,
      clean: true,
      reconnectPeriod: 1000, // ms
      connectTimeout: 24 * 3600 * 1000, // ms
      // keepalive: 60 // 心跳
    }
    return { url, options }
  }
  // WebSocket
  useEffect(() => {
    const isLogin = getLoginStatus()
    if (isLogin && client) {
      clientRef.current = client
      client.on('connect', () => {
        console.log('WebSocket：连接成功')
        if(!msgSessionIdRef.current){
          getUserBindSessionAjax().then((data: any) => {
            if (data.code === 0) {
              mqttSub({ topic: data.result?.msgSessionId, qos: 1 })
              msgSessionIdRef.current = data.result?.msgSessionId
            }
          })
        }else{
          // 自动重连时的订阅
          mqttSub({ topic: msgSessionIdRef.current, qos: 1 })
        }
      })

      client.on('error', err => {
        console.error('WebSocket 连接失败: ', err)
        client?.end?.()
      })

      client.on('reconnect', (a,b) => {
        console.log('重新连接',a,b)
      });

      client.on('message', (topic, socketMessage) => {
        // 设置接收的消息
        const data = JSON.parse(socketMessage || '{}')
        console.log('设置接收的消息', data)
        if (data?.status === 5) {
          message.error('生成失败，请重新生成或制作。')
          // mqttUnSub({ topic: mobx.cotOutDetail.taskId, qos: 1 })
          return
        }
        // 支付
        if (data.topic === 'PAY_SUCC_NOTIFY') {
          // 订单支付成功后，广播回调通知
          //       {
          //         "remainTryTimes": 2,
          //         "result": {
          //           "orderId": "64a929df65bcb332e9673247",
          //           "amount": 80,
          //           "orderTime": 23525245346321152
          //         },
          //         "status": 4,
          //         "taskId": "任务ID",
          //         "topic": "PAY_SUCC_NOTIFY"
          // }
          gioTrackEvent(eventMap.CB_revenue)
          eventBus.emit(EVENT_NEMES.EVENT_PAY, JSON.parse(data.result))
        }
      })
    }
  }, [client])

  // 订阅
  const mqttSub = subscription => {
    if (client) {
      const { topic, qos } = subscription
      client.subscribe?.(topic, { qos }, error => {
        if (error) {
          console.log('layout:Subscribe to topics error', error)
          message.warning('请重新登录后再使用。')
          return
        }
        console.log(`Subscribe to topics: ${topic}`)
      })
    }
  }

  // 取消订阅
  const mqttUnSub = subscription => {
    const clientInstance = client || clientRef.current
    if (clientInstance) {
      const { topic, qos } = subscription
      clientInstance?.unsubscribe?.(topic, { qos }, error => {
        if (error) {
          console.log('Unsubscribe error', error)
          return
        }
        console.log(`unsubscribed topic: ${topic}`)
      })
    }
  }

  const mqttDisconnect = () => {
    const clientInstance = client || clientRef.current
    if (clientInstance) {
      try {
        clientInstance.end(false, () => {
          console.log('disconnected successfully')
        })
      } catch (error) {
        console.log('disconnect error:', error)
      }
    }
  }

  useEffect(() => {
    if (globalStore?.userInfo.token) {
      const { url, options } = getMqttConfig()
      setClient(mqtt.connect(url, options))
    }
    // 卸载逻辑
    return () => {
      if (msgSessionIdRef.current) {
        mqttUnSub({ topic: msgSessionIdRef.current, qos: 1 })
        mqttDisconnect()
        msgSessionIdRef.current = null
      }
    }
  }, [globalStore?.userInfo.token])

  return null
}

export default observer(Mqtt)
